import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { tokens } from './tokens';
import { typography } from './typography';
import breakpoints from './breakpoint';
import button from './overrides/button';
import textfield from './overrides/textfield';
import { createContext, useMemo, useState } from 'react';
import divider from './overrides/divider';
import menu from './overrides/menu';

// mui theme settings

export const themeSettings = (mode) => {
  const colors = tokens(mode);
  return {
    palette: {
      mode: mode,
      ...(mode === 'light'
        ? {
          ...colors
        } : {
        
        }
      )
    },
    typography: typography,
    breakpoints: breakpoints,
    shape: {
      borderRadius: 4,
    },
    spacing: 8,
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: {
            background: colors.base.white, 
          },
        },
      },
      MuiButton: button,
      MuiTextField: textfield,
      MuiDivider: divider,
      MuiMenu: menu,
    },
    custom: {
      drawerWidth: {
        xs: '100vw',
        sm: '90vw',
        md: '85vw',
        lg: '75vw',
        xl: '60vw',
        max: '1054px',
      },
    },
    /*TODO: remove these setting from colors to locations once everything is done */
    colors: {
      title: '#141414',
      subtitle: '#e33371',
      searchbox: '#f0f0f0',
      grey: '#a3a3a3',
      bar: '#e33371',
      red: '#FF3838',
      green: '#1b5e20',
    },
    status: {
      account: {
        active: '#1b5e20',
        trail: '#FF7900',
        inactive: '#616161'
      },
      expense: {
        paid: '#00E200',
        new: '#1565c0',
        overdue: '#FF3838',
        unpaid: '#2DCCFF',
      },
      order: {
        open: '#1565c0',
        progress: '#7b1fa2',
        yard: '#FF7900',
        yard_pull: '#FF3838',
        yard_in: '#FF3838',
        delivered: '#4caf50',
        complete: '#1b5e20',
        completed: '#1b5e20',
      },
      leg: {
        new: '#2196f3',
        covered: '#2DCCFF',
        yard: '#FF7900',
        yard_pull: '#FF7900',
        yard_in: '#FF7900',
        transit: '#3f50b5',
        delivered: '#00E200',
        terminal: '#00E200',
        complete: '#00E200',
        completed: '#00E200',
        container_in: '#56F000',
        default: '#f0f0f0',
      },
      location: {
        new: '#2196f3',
        transit: '#3f50b5',     
        check_in: '#3f50b5',
        drop: '#00E200',
        detention_start: '#FFB302',
        loading: '#3f50b5',
        unloading: '#3f50b5',
        loaded: '#00E200',
        delivered: '#00E200',
        checkout: '#00E200',
        done: '#00E200',
        default: '#f0f0f0',
      }
    }
  };
};

export const ColorModeContext = createContext({
  toggleColorMode: () => {}
});

export const useMode = () => {
  const [mode, setMode] = useState('light');
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'))
    }),[]
  );
  const FSTheme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  
  return [responsiveFontSizes(FSTheme), colorMode];/* This will scale down the font sizes as per viewport */
};

// import { createTheme } from '@mui/material/styles';
// import { colors } from '@mui/material';

// import shadows from './shadows';
// import typography from './typography';

// const FSTheme = createTheme({
//   status: {
//     account: {
//       active: '#1b5e20',
//       trail: '#FF7900',
//       inactive: '#616161'
//     },
//     expense: {
//       paid: '#00E200',
//       new: '#1565c0',
//       overdue: '#FF3838',
//       unpaid: '#2DCCFF',
//     },
//     order: {
//       open: '#1565c0',
//       progress: '#7b1fa2',
//       yard: '#FF7900',
//       yard_pull: '#FF3838',
//       yard_in: '#FF3838',
//       delivered: '#4caf50',
//       complete: '#1b5e20',
//       completed: '#1b5e20',
//     },
//     leg: {
//       new: '#2196f3',
//       covered: '#2DCCFF',
//       yard: '#FF7900',
//       yard_pull: '#FF7900',
//       yard_in: '#FF7900',
//       transit: '#3f50b5',
//       delivered: '#00E200',
//       terminal: '#00E200',
//       complete: '#00E200',
//       completed: '#00E200',
//       container_in: '#56F000',
//       default: '#f0f0f0',
//     },
//     location: {
//       new: '#2196f3',
//       transit: '#3f50b5',     
//       check_in: '#3f50b5',
//       drop: '#00E200',
//       detention_start: '#FFB302',
//       loading: '#3f50b5',
//       unloading: '#3f50b5',
//       loaded: '#00E200',
//       delivered: '#00E200',
//       checkout: '#00E200',
//       done: '#00E200',
//       default: '#f0f0f0',
//     }
//   },
//   colors: {
//     title: '#141414',
//     subtitle: '#e33371',
//     searchbox: '#f0f0f0',
//     grey: '#a3a3a3',
//     bar: '#e33371',
//     red: '#FF3838',
//     green: '#1b5e20',
//   },
//   palette: {
//     background: {
//       dark: '#F4F6F8',
//       default: colors.common.white,
//       paper: colors.common.white
//     },
//     primary: {
//       main: '#0D46A1'
//     },
//     secondary: {
//       light: '#e33371',
//       main: '#e33371',
//       dark: '#9a0036',
//     },
//     error: {
//       main: '#e57373'
//     },
//     warning: {
//       main: '#ffb74d'
//     },
//     info: {
//       main: '#64b5f6'
//     },
//     success: {
//       main: '#81c784'
//     },
//     text: {
//       primary: colors.blueGrey[900],
//       secondary: colors.blueGrey[600],
//     },
//   },
//   components: {
//     // MUI v5 uses 'components' instead of 'overrides'
//     MuiDataGrid: {
//       styleOverrides: {
//         root: {        
//           '& .MuiDataGrid-cell': {
//             borderBottom: 'none',
//           },
//           '& .MuiDataGrid-columnHeader': {
//             fontWeight: '900',
//           }, 
//           '& .MuiDataGrid-columnHeaderWrapper': {
//             backgroundColor: '#f0f0f0',
//           },          
//           '& .MuiDataGrid-columnHeaderTitle': {
//             fontWeight: '900 !important',
//             borderBottom: 'none',
//           },
//           '& .MuiDataGrid-columnsContainer': {
//             background: '#f0f0f0'
//           }
//         },
//         columnsContainer: {
//           background: '#f0f0f0'
//         }
		
						 
							 
//       }
//     },
//     MuiListItem: {
//       styleOverrides: {
//         root: {
//           '&.Mui-selected': {
//             color: 'primary',
//             backgroundColor: '#e33371'
//           }
//         }
//       }
//     },
//     MuiMenu: {
//       styleOverrides: {
//         paper: {
//           minWidth: '30ch',
//           marginTop: '30px',
//         }
//       }
//     }
//   },
//   shadows,
//   typography
// });

// export default FSTheme;